package oldcomponents.rules

import bootstrap.DateRangePicker
import oldcomponents.dropdownSelect
import js.core.jso
import kotlinx.datetime.*
import kotlinx.html.InputType
import kotlinx.html.classes
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onKeyDownFunction
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.KeyboardEvent
import react.dom.div
import react.dom.input
import react.dom.label
import react.fc
import react.useEffect
import react.useState
import ru.it_mozaika.sender.common.models.Rule


external interface SubscribeDateRuleProps : RuleProps<Rule.SubscribeDate> {
    var subscriptionLists: Map<String, String>
}

val subscribeDateRule = fc<SubscribeDateRuleProps> { props ->

    var dateText by useState("")
//    useEffect(props.item.date) {
//        sendTimeText = sendTime?.toLocalDateTime(TimeZone.currentSystemDefault())?.toString().orEmpty()
//        val local = props.item.date.toLocalDateTime(TimeZone.currentSystemDefault())
//        dateText = "${local.dayOfMonth.toString().padStart(2, '0')}.${local.monthNumber.toString().padStart(2, '0')}.${local.year}"
//    }

//    val values = listOf(
//        "false:true" to "Меньше",
//        "true:true" to "Меньше или равно",
//        "true:false" to "Больше или равно",
//        "false:false" to "Больше",
//    )
//
//    div("form-group row d-flex align-items-center mb-1 pl-2") {
//        label("col-3 form-control-label") { +"Дата подписки:" }
//        div("col-2 p-0") {
//            child(dropdownSelect) {
//                attrs {
//                    dropdownOpenDefault = false
//                    multiSelect = false
//                    showFilter = false
//                    currentValue = mapOf(when {
//                        !props.item.isEqual && props.item.isBefore -> values[0]
//                        props.item.isEqual && props.item.isBefore -> values[1]
//                        props.item.isEqual && !props.item.isBefore -> values[2]
//                        else -> values[3]
//                    })
//                    selectValues = values
//                    onSave = { value ->
//                        val (isEqual, isBefore) = value.keys.firstOrNull()?.split(":")?.map { it.toBooleanStrictOrNull() ?: false } ?: listOf(false, false)
//                        props.onChange(props.item.copy(isEqual = isEqual, isBefore = isBefore))
//                    }
//                }
//            }
//        }
//        div("col-3") {
//            DateRangePicker {
//                attrs.initialSettings = jso {
//                    singleDatePicker = true
//                    timePicker = false
//                    locale = jso {
//                        format = "DD.MM.YYYY"
//                        applyLabel = "Выбрать"
//                        cancelLabel = "Отмена"
//                        daysOfWeek = arrayOf("ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ")
//                        monthNames = arrayOf("Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь")
//                        firstDay = 1
//                    }
//                    autoApply = true
//                    autoUpdateInput = false
//                }
//                attrs.onCallback = { start, _, _ ->
//                    val localDate = LocalDateTime(
//                        start.year() as Int,
//                        (start.month() as Int) + 1,
//                        start.date() as Int,
//                        0,
//                        0,
//                        0
//                    )
//                    props.onChange(props.item.copy(date = localDate.toInstant(TimeZone.currentSystemDefault())))
//                }
//                input(InputType.text) {
//                    val classes = mutableSetOf("form-control")
//                    attrs.classes = classes
//                    attrs.value = dateText
//                    attrs.onKeyDownFunction = { event ->
//                        val key = (event.asDynamic().nativeEvent as? KeyboardEvent)?.key?.lowercase()
//                        if (key == "enter") {
//                            try {
//                                val splitValue = dateText.split(".")
//                                val day = splitValue[0].toInt()
//                                val month = splitValue[1].toInt()
//                                val year = splitValue[2].toInt()
//
//                                props.onChange(props.item.copy(date = LocalDateTime(year, month, day, 0, 0, 0).toInstant(TimeZone.currentSystemDefault())))
//                            } catch (e: Exception) { }
//                        }
//                    }
//                    attrs.onChangeFunction = { event ->
//                        dateText = (event.target as? HTMLInputElement)?.value.orEmpty()
//                    }
//                }
//            }
//        }
//        div("col-4 p-0") {
//            child(dropdownSelect) {
//                attrs {
//                    dropdownOpenDefault = false
//                    multiSelect = true
//                    showFilter = true
//                    currentValue = props.item.listIds.associateWith { props.subscriptionLists[it].orEmpty() }
//                    selectValues = props.subscriptionLists.map { it.key to it.value }
//                    onSave = {
//                        props.onChange(props.item.copy(listIds = it.keys.toList()))
//                    }
//                }
//            }
//        }
//    }
}
